import { Pipe, PipeTransform } from '@angular/core';
import { ChainContext } from 'rio-models';

@Pipe({
  name: 'promptContext',
})
export class PromptContextPipe implements PipeTransform {
  transform(option: ChainContext): string {
    switch (option) {
      case ChainContext.previousOutput:
        return 'PromptChains.Previous Output';
      case ChainContext.previousOutputAndOriginal:
        return 'PromptChains.Previous Output + Original';
      case ChainContext.allPreviousOutputsAndOriginal:
        return 'PromptChains.All previous Outputs + Original';
    }
  }
}
